import { Expose } from 'class-transformer';
import type BasketProductChoice from '../types/BasketProductChoice'
import type ImageInterface from '../types/Image';
import type MetaDataInterface from '../types/MetaData';
import type ItemCustomData from '../types/CustomData';

export default class BasketProduct {
  @Expose() basecost: number = 0;
  @Expose() choices: BasketProductChoice[] = [];
  @Expose() custom_data: ItemCustomData = {
    vegan: false,
    vegetarian: false,
    gluten_free: false,
    dairy_free: false,
    nut_free: false,
    soy_free: false,
    addon_products: {}
  }
  @Expose() id: number = 0;
  @Expose() chainproductid: number = 0;
  @Expose() productId: number = 0;
  @Expose() name: string = "";
  @Expose() quantity: number = 0;
  @Expose() recipient: string = "";
  @Expose() specialinstructions: string = "";
  @Expose() totalcost: number = 0;
  @Expose() description: string = "";
  // Going to force some attributes that typically exist on the base product onto the basketproduct
  @Expose() images: ImageInterface[] = [];
  @Expose() metadata: MetaDataInterface[] = [];
  @Expose() feeds: number[] = [0,0,0];

  getImageByKey = (key: string) => {
    if (this.images) {
      const keyedImages = this.images.filter(img => {
        return img.position == key
      })
      return keyedImages.length > 0 ? keyedImages[0] : null;
    } else {
      return null
    }
  }

  getMetaDataByKey = (key: string) => {
    let data = null;
    if (this.metadata) {
      data = this.metadata.find(md => {
        return md.key == key
      })
    }

    return data ? data.value : null;
  }

  isCatering = (): boolean => {
    let catering = false;

    if (this.getMetaDataByKey('catering')) {
      catering = true;
    }

    return catering;
  }
}